import React, { useState, useEffect } from 'react';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';
import { authLogoutAction } from 'store/actions/Actions';
import classNames from 'classnames'
import { connect } from 'react-redux';
// import profileImg from "assets/img/leonardo-da-vinci.jpg";

const UserPanel = (props) => {
  const [state, setState] = useState({
    isUserMenuOpen: false
  });

  const [companyName, setCompanyName] = useState("");
  const [siteName, setSiteName] = useState("");

  const { AuthReducer, UserOrgSiteReducer } = props;

  let userRole = '';

  // if (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) {
  //   userRole = ' / Admin';
  // }

  if (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_site_admin) {
    userRole = ' / Site Admin';
  }

  if (UserOrgSiteReducer.selected && (UserOrgSiteReducer.selected.is_org_admin || UserOrgSiteReducer.selected.is_org_admin_label)) {
    userRole = ' / Org Admin';
  }

  if (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) {
    userRole = ' / Officer';
  }

  if (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) {
    userRole = ' / Super Admin';
  }

  useEffect(() => {
    if (UserOrgSiteReducer.organizations && UserOrgSiteReducer.selected.org && UserOrgSiteReducer.selected && AuthReducer.userData) {
      try {
        const orgId = parseInt(UserOrgSiteReducer.selected.org);
        if (UserOrgSiteReducer.organizations && UserOrgSiteReducer.organizations[orgId]) {
          setCompanyName(UserOrgSiteReducer.organizations[orgId].name);
        }
      } catch (error) {
        console.log('error setting company name!', error);
      }

      try {
        const orgId = parseInt(UserOrgSiteReducer.selected.org);
        if (UserOrgSiteReducer.organizations && UserOrgSiteReducer.organizations[orgId]) {
          if (UserOrgSiteReducer.organizations[orgId].sites[UserOrgSiteReducer.selected.site] && UserOrgSiteReducer.organizations[orgId].sites[UserOrgSiteReducer.selected.site]) {
            setSiteName(UserOrgSiteReducer.organizations[orgId].sites[UserOrgSiteReducer.selected.site]);
          } else {
            setSiteName("All Sites");
          }
        } else {
          setSiteName("All Sites");
        }
      } catch (error) {
        console.log('error setting site name!', error);
      }
    }

  }, [UserOrgSiteReducer.organizations, UserOrgSiteReducer.selected, AuthReducer.userData])

  const logout = () => {
    props.authLogoutAction();
  }
  const toggleUserMenu = ({closeOnly} = {}) => {
    if (closeOnly === true) {
      if (state.isUserMenuOpen) {
        setState({ isUserMenuOpen: false });
      }
    } else {
      setState({ isUserMenuOpen: !state.isUserMenuOpen });
    }
  }

  const userPanelClassNames = classNames('user-panel', {'user-menu-open': state.isUserMenuOpen === true});
  const userMenuClassNames = classNames('user-menu', {'open': state.isUserMenuOpen === true});

  const imageSrc = (AuthReducer.userData && AuthReducer.userData.image !== "") ? `${process.env.REACT_APP_BASE_API_URL}${AuthReducer.userData.image}` : '/profile.png';

  return (
    <ClickAwayListener onClickAway={() => toggleUserMenu({closeOnly: true})}>
    <React.Fragment>
      <div className={userPanelClassNames} onClick={() => toggleUserMenu()}>
        <div className='user-thumbnail'>
          <img src={imageSrc} alt="" />
        </div>
        <div className='user-info'>
          <div className='user-name'>{AuthReducer.userData ? AuthReducer.userData.name : ''}</div>
          <div className='user-company'>{companyName}<br /><small>{siteName}{userRole}</small></div>
        </div>
        <div className='user-menu-arrow'>
          <i className='fas fa-caret-right' />
        </div>
      </div>
      <div className={userMenuClassNames}>
        <ul>
          <li><Link to='/settings'><i className='fas fa-cogs' /><span>Settings</span></Link></li>
          <li><a href='https://compliancygroup.freshdesk.com/support/home' target="_blank" rel="noopener noreferrer" ><i className='fas fa-user-graduate' /><span>Knowledge Base</span></a></li>
          <li><a href="/login/site"><i className='fal fa-city' /><span>Change Org</span></a></li>
          <li><a href='/' onClick={(e) => {e.preventDefault(); logout()}}><i className='fas fa-sign-out' /><span>Logout</span></a></li>
        </ul>
      </div>
    </React.Fragment>
    </ClickAwayListener>
  )
}

const mapStateToProps = (state/* , ownProps */) => (
  {
    AuthReducer: state.AuthReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
  }
);

const mapDispatchToProps = {
  authLogoutAction
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPanel);
